import { useState, useEffect } from "react";
import { X, Copy, Check, Tag } from "lucide-react";
import { PROMO } from "../data/mock";

export const PromoBar = () => {
  const [visible, setVisible] = useState(true);
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    const dismissed = sessionStorage.getItem("promo-dismissed");
    if (dismissed) setVisible(false);
  }, []);

  if (!PROMO.active || !visible) return null;

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(PROMO.code);
      setCopied(true);
      setTimeout(() => setCopied(false), 1800);
    } catch (e) {}
  };

  const handleDismiss = () => {
    sessionStorage.setItem("promo-dismissed", "1");
    setVisible(false);
  };

  return (
    <div className="relative bg-gradient-to-r from-sky-700 via-sky-600 to-sky-700 text-white text-xs sm:text-sm z-[60]" data-testid="promo-bar">
      <div className="max-w-7xl mx-auto px-4 py-2 flex items-center justify-center gap-2 sm:gap-4 flex-wrap">
        <div className="flex items-center gap-2">
          <Tag className="w-3.5 h-3.5 text-lime-300 flex-shrink-0" />
          <span className="font-semibold">{PROMO.headline}</span>
          <span className="hidden sm:inline text-sky-100">·</span>
          <span className="hidden sm:inline text-sky-100">{PROMO.subline}</span>
        </div>
        <button
          onClick={handleCopy}
          className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-white/15 hover:bg-white/25 border border-white/30 font-mono text-[11px] sm:text-xs font-bold transition-colors"
          data-testid="promo-copy-btn"
        >
          {copied ? <Check className="w-3 h-3 text-lime-300" /> : <Copy className="w-3 h-3" />}
          {PROMO.code}
        </button>
      </div>
      <button
        onClick={handleDismiss}
        className="absolute right-2 top-1/2 -translate-y-1/2 w-6 h-6 rounded-full hover:bg-white/20 flex items-center justify-center transition-colors"
        aria-label="Dismiss promo"
        data-testid="promo-dismiss"
      >
        <X className="w-3.5 h-3.5" />
      </button>
    </div>
  );
};
